import { render, staticRenderFns } from "./comparisons.vue?vue&type=template&id=0dc2975c&"
import script from "./comparisons.vue?vue&type=script&lang=js&"
export * from "./comparisons.vue?vue&type=script&lang=js&"
import style0 from "./comparisons.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports